import { FormDef, FormDocSimple } from "../types/form";
import { DocListFilter } from "../types/product";
import { get, post } from "./fetch.core";

async function listDef() {
  const res = await get<FormDef[]>("/admin/form/listDef");
  return res.data;
}

async function listDoc(data: Partial<DocListFilter>) {
  if (!data.search) {
    delete data.search;
  }
  if (data.date) {
    if (!data.date.from || !data.date.to) delete data.date;
  }
  const res = await post<{ size: number; data: FormDocSimple[] }>(`/admin/form/listDoc`, data);
  return res.data;
}

async function singleDef(formDefId: string) {
  const res = await get<FormDef>(`/admin/form/singleDef?formDefId=${formDefId}`);
  return res.data;
}

async function singleDoc(id: string) {
  const res = await get<FormDocSimple>(`/admin/form/singleDoc?id=${id}`);
  return res.data;
}

async function updateDef(data: any) {
  await post("/admin/form/updateDef", data);
}

async function createDef(data: any) {
  await post("/admin/form/createDef", data);
}

const obj = {
  listDef,
  listDoc,
  singleDef,
  singleDoc,
  updateDef,
  createDef,
};

export default obj;
